module.exports = __webpack_public_path__ + "img/tu-2.adc6e2a9.png";